<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <!-- <div class="item">
            <span class="label">{{ $t("g.create_at") }}</span>
            <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
              unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
              :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
            </el-date-picker>
          </div> -->
        <div class="item">
          <span class="label">手机号</span>
          <el-input class="inp" size="small" v-model="formData.Mobile" placeholder="请输入手机号"></el-input>
        </div>
        <!-- <div class="item">
            <span class="label">{{ $t('g.operator') }}</span>
            <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.valCode"
              :props="formData.props" :options="render.cascade_options_direct" />
          </div> -->
        <div class="item">
          <span class="label">用户ID</span>
          <el-input class="inp" size="small" v-model="formData.Id" placeholder="请输入用户ID"></el-input>
        </div>
        <div class="item">
          <span class="label">用户昵称</span>
          <el-input class="inp" size="small" v-model="formData.Nickname" placeholder="请输入昵称"></el-input>
        </div>
      </div>
      <div class="userInfo">账户剩余可充值天数：{{ formData.ComboDays }}天。有效套餐用户{{ formData.total }}位</div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" :stripe="true" style="width: 100%">
        <el-table-column prop="Id" label="ID">
        </el-table-column>
        <el-table-column prop="Nickname" label="用户昵称">
        </el-table-column>
        <el-table-column prop="IdName" label="姓名">
        </el-table-column>
        <el-table-column prop="Mobile" label="手机号">
        </el-table-column>
        <el-table-column prop="RestDays" label="剩余天数">
        </el-table-column>
        <!-- <el-table-column prop="AgentCode" v-if="!isOperator()" :label="$t('g.agent_code')" width="100">
            </el-table-column> -->
        <el-table-column prop="CreateAtStr" label="套餐到期时间">
        </el-table-column>
        <el-table-column width="120" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button @click="func.recharge(scope.row)" class="btn-edit" type="primary">充值</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="充值" v-model="formData.rechargeType" center align-center style="width:40%">
      <div class="userInfo">账户剩余可充值天数：{{ formData.ComboDays }}天</div>
      <el-form label-width="120px" :model="formData.rechargeInfo">
        <el-form-item label="账号ID">
          <el-input v-model="formData.rechargeInfo.UserId" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input v-model="formData.rechargeInfo.Nickname" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="formData.rechargeInfo.Mobile" disabled></el-input>
        </el-form-item>
        <el-form-item label="充值天数">
          <el-input v-model="formData.rechargeInfo.Days"></el-input>
        </el-form-item>
        <el-form-item label="收取金额">
          <el-input v-model="formData.rechargeInfo.Money"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="default" @click="formData.rechargeType = false">{{ $t('g.btn_cancel') }}</el-button>
          <el-button type="primary" @click="func.rechargeSave()">{{ $t('g.btn_confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, onMounted, computed, watch } from 'vue'
import { shortcuts, operators, operatorList, cascade_options_direct } from '@/data/default'
import { toDay } from '@/common/func'
import axios from "axios"
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import cfg from '@/common/conf'
import { user, isOperator } from '@/data/token'
import i18n from '@/data/i18n/index'

export default {
  name: 'BillRefundRecord',
  setup() {
    const t = i18n.global.t
    const tableData = []
    const render = {
      devTypes: [
        {
          label: t("device.types.ebox"),
          value: 1
        },
        {
          label: t("device.types.cbox"),
          value: 2
        },
        {
          label: t("device.types.pile"),
          value: 3
        },
      ],
      operators,
      operatorList,
      shortcuts,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      Id: '',
      Mobile: '',
      Nickname: '',
      rechargeType: false,
      devices: [],
      valAddDevType: 1,
      valAddOperator: (operatorList && operatorList.length) ? operatorList[0].value : "",
      billData: {},
      valTime: '',
      curPage: 1,
      pageSize: 10,
      total: 0,
      valName: '',
      valCode: 0,
      dialogVisible: false,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "CodePath",
        emitPath: false,
        checkStrictly: true
      },
      rechargeInfo: {
        UserId: '',
        Days: '',
        Money: '',
        Type: 1
      },
      ComboDays: 0
    })
    const func = {
      async expand(row, state) {
        if (state.length) {
        }
      },
      search() {
        console.log('formData', formData)
        func.loadData()
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      async recharge(row) {
        formData.rechargeInfo.UserId = row.Id
        formData.rechargeInfo.Nickname = row.Nickname
        formData.rechargeInfo.Mobile = row.Mobile
        formData.rechargeType = true
        console.log('row值', row)
      },
      async rechargeSave() {
        if (!formData.rechargeInfo.Days || formData.rechargeInfo.Days == '' || formData.rechargeInfo.Days == 0) {
          ElMessage({
            type: 'error',
            message: '请填写充值天数'
          })
          return
        }
        console.log('充值信息', formData.rechargeInfo.Days)
        let params = {
          Type: formData.rechargeInfo.Type,
          UserId: formData.rechargeInfo.UserId,
          Days: formData.rechargeInfo.Days,
          Money: formData.rechargeInfo.Money
        }
        let res = await axios.post("/admin/agencyRecharge/add", params)
        if (res == '充值成功') {
          ElMessage({
            type: 'success',
            message: '充值成功'
          })
          formData.rechargeType = false
        } else {
          ElMessage({
            type: 'error',
            message: '充值失败'
          })
        }
        console.log('充值结果', res)
      },
      async getUserInfo() {
        let res = await axios.get("/admin/userDetail")
        formData.ComboDays = res.ComboDays
        console.log('用户信息', formData.ComboDays)
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.Id) {
            params.Id = formData.Id
          }
          if (formData.Mobile) {
            params.Mobile = formData.Mobile
          }
          if (formData.Nickname) {
            params.Nickname = formData.Nickname
          }
          // if (formData.valDevNo) {
          //   params.dev_id = formData.valDevNo
          // }
          // if (formData.valTime) {
          //   params.startAt = Math.floor(Date.parse(formData.valTime[0]+ " 00:00:00") / 1000)
          //   params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          // }
          let res = await axios.get(`/admin/agencyRecharge/saerchuser`, {
            params
          })
          console.log('数据111', res)
          formData.total = res.Total
          res.List.map((item) => {
            if (item.AllEndAt) {
              item.CreateAtStr = toDay(item.AllEndAt)
            } else {
              item.CreateAtStr = '--'
            }
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize

          func.getUserInfo()
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      func.loadData()
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  .table-detail {
    display: flex;
    flex-direction: column;
    margin-right: 9.375rem;
    padding-left: 4rem;
    padding-top: 1rem;

    .orders {
      .order {
        display: flex;
        margin-bottom: 0.5rem;
        align-items: center;

        >div {
          margin-right: 1rem;
        }
      }
    }

    >.item {
      margin-right: 0.625rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.625rem;
      color: #333333;

      >img {
        margin-left: 0.625rem;
        width: 4rem;
        height: 3rem;
        object-fit: cover;
      }
    }
  }

  .boximg {
    width: 4rem;
    height: 3rem;
    object-fit: cover;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;

        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }

    .userInfo {
      text-align: left;
      margin-top: 20px;
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 88%;
      margin: 0 auto;
    }

    &.line-3 {
      :deep(.el-form-item) {
        width: 33%;
      }
    }

    .inp {
      width: 100%;
    }

    .avatar-uploader {
      :deep(.el-upload) {
        border: 1px dashed #d9d9d9;
        border-radius: 0.375rem;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
          border-color: #409eff;
        }
      }
    }

    .avatar-uploader-icon {
      font-size: 1.75rem;
      color: #8c939d;
      width: 11rem;
      height: 9rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .avatar {
      width: 11rem;
      height: 9rem;
      display: block;
      object-fit: cover;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  .userInfo {
    margin: 5px 0px 15px 0px;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
  }
}
</style>
<!-- 
-->